import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { MaterialHeaderRow, RoutingHeaderRow } from 'model/Project/BoMItemRow'
import { ProjectState } from 'store/Project/ProjectTypes'

export const deleteBomItemFromStore: CaseReducer<
  ProjectState,
  PayloadAction<string>
> = (state, action) => {
  const bomItem =
    state.flatView[action.payload] || state.treeView[action.payload]

  switch (bomItem?.type) {
    case 'Row': {
      delete state.flatView[action.payload]
      delete state.treeView[action.payload]

      state.partTypeIds = state.partTypeIds.filter(
        (id) => id !== action.payload
      )
      state.structurePartTypeIds = state.structurePartTypeIds.filter(
        (id) => id !== action.payload
      )

      state.materialHeadersIds.forEach((x) => {
        const materialHeader = state.flatView[x] as MaterialHeaderRow
        materialHeader.partTypeIds = materialHeader.partTypeIds.filter(
          (id) => id !== action.payload
        )
        materialHeader.filteredPartTypeIds =
          materialHeader.filteredPartTypeIds.filter(
            (id) => id !== action.payload
          )
      })

      state.routingHeadersIds.forEach((x) => {
        const routingHeader = state.flatView[x] as RoutingHeaderRow
        routingHeader.partTypeIds = routingHeader.partTypeIds.filter(
          (id) => id !== action.payload
        )
        routingHeader.filteredPartTypeIds =
          routingHeader.filteredPartTypeIds.filter(
            (id) => id !== action.payload
          )
      })

      const parent =
        state.flatView[bomItem.parentId] || state.treeView[action.payload]
      if (parent.type === 'AssemblyHeader') {
        parent.filteredPartTypeIds = parent.filteredPartTypeIds.filter(
          (id) => id !== action.payload
        )
        parent.assembly.partTypeIds = parent.assembly.partTypeIds?.filter(
          (id) => id !== action.payload
        )
      }

      break
    }
    case 'AssemblyHeader': {
      delete state.flatView[action.payload]
      delete state.treeView[action.payload]

      state.assemblyHeadersIds = state.assemblyHeadersIds.filter(
        (id) => id !== action.payload
      )
      break
    }
  }
}
